export function parseFiltersParamToAttrIds(filters: any): number[] {
  if (Array.isArray(filters)) {
    return filters.map(Number);
  } else if (filters === "" || filters === undefined || filters == null) {
    return [];
  } else {
    return filters.split(",").map(Number);
  }
}
